import { makeAutoObservable } from "mobx";

import { Cell } from "./Cell";
import { Column } from "./Column";
import MealPlanFormStore from "./MealPlanFormStore";
import { PlannedMeal } from "./PlannedMeal";

export default class Cells {
  active?: Cell;

  // Store already created Cell instances here so that there's only one Cell
  // instance lying around for each pair of DayColumn and PlannedMeal.
  instances: Map<Column, Map<PlannedMeal, Cell>> = new Map();
  private store: MealPlanFormStore;

  get first(): Cell {
    return this.at(0, 0);
  }

  constructor(store: MealPlanFormStore) {
    makeAutoObservable(this);
    this.store = store;
  }

  get(day: Column, plannedMeal: PlannedMeal): Cell {
    const dayCells = this.getDay(day);
    if (!dayCells.has(plannedMeal)) {
      dayCells.set(plannedMeal, new Cell(this.store, plannedMeal, day));
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return dayCells.get(plannedMeal)!;
  }

  getDay(day: Column): Map<PlannedMeal, Cell> {
    if (!this.instances.has(day)) this.instances.set(day, new Map());
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.instances.get(day)!;
  }

  at(dayColumnIndex: number, plannedMealIndex: number): Cell {
    const dayColumn = this.store.columns.at(dayColumnIndex);
    const plannedMeal = this.store.rows.at(plannedMealIndex);
    return this.get(dayColumn, plannedMeal);
  }

  setActive(cell: Cell): void {
    this.active = cell;
  }

  clearActive(): void {
    this.active = undefined;
  }

  up(): Cell {
    this.active = this.active
      ? this.get(
          this.active.column,
          this.store.rows.previous(this.active.plannedMeal)
        )
      : this.first;
    return this.active;
  }

  down(): Cell {
    this.active = this.active
      ? this.get(
          this.active.column,
          this.store.rows.next(this.active.plannedMeal)
        )
      : this.first;
    return this.active;
  }

  left(): Cell {
    this.active = this.active
      ? this.get(
          this.store.columns.previous(this.active.column),
          this.active.plannedMeal
        )
      : this.first;
    return this.active;
  }

  right(): Cell {
    this.active = this.active
      ? this.get(
          this.store.columns.next(this.active.column),
          this.active.plannedMeal
        )
      : this.first;
    return this.active;
  }
}
